<template>
    <div class="body">
        <div class="cont_title">充值服务
            <p class="returnBtn" @click="jump('duanxin')">返回</p>
        </div>
        <div class="chongzhiLi">
            <p class="chongzhiLiT">短信包 :</p>
            <ul class="duanxinBox">
                <li v-for="(item,index) in price_list" @click="tabs(index,item.val,item.name,item.price)"
                    :class="ul_index == index ? 'active' : ''" v-if="index !== 4">{{item.name}}条={{item.price}}元
                </li>
            </ul>
            <div style="clear: both;width: 100%;height: 30px"></div>
        </div>

        <div class="youhui" v-if="nodata == true">
            <div v-for="(item,index) in price_list" @click="tabs(index,item.val,item.name,item.price)"
                 :class="ul_index == index ? 'tehui' : ''" v-if="index === 4" class="tehuiA">
                {{item.name}}条={{item.price}}元
            </div>
            <div class="tehuiB">特惠</div>
            <div class="right_txt">注：特惠短信包仅优惠一次，第二次购买将恢复原价</div>
            <div style="clear:both"></div>
        </div>

        <!--付款码-->
        <el-dialog
                :visible.sync="dialogVisible"
                :before-close="handleClose"
                :show-close = "!dialogVisible"
                width="25%">

            <div style="position: relative;">
                <div style="position: absolute;top: -10px;" class="header">微信支付</div>
            </div>
            <div style="text-align: center;margin-top: 20px;">
                <img :src="scan_code" width="160"/><br/>
                <img src="/static/qmsj/img/weixinbiao_06.png"/>
                <p style="color: red;">支付成功前请勿关闭此页面,否则将导致充值失败!</p>
            </div>
        </el-dialog>

        <div class="querendingd">
            <div class="queT">确认订单信息</div>
            <div class="listB">
                <div class="listsT">
                    <ul>
                        <li v-if="ul_index === 4" class="listr jine">133.28元</li>
                        <li v-if="ul_index !== 4" class="listr jine">{{total_price}}元</li>
                        <li><strong>商品总金额：</strong></li>
                    </ul>
                </div>
                <div class="listsT">
                    <ul>
                        <li class="listr xinxLiang">{{note}}条</li>
                        <li><strong>短信包：</strong></li>
                    </ul>
                </div>
                <div class="listsT">
                    <ul>
                        <li v-if="ul_index === 4" class="listr youhuiq">33.28元</li>
                        <li v-if="ul_index !== 4" class="listr youhuiq">0元</li>
                        <li><strong>优惠：</strong></li>
                    </ul>
                </div>
                <div class="listsT" style="height: 70px;line-height: 70px;border: none">
                    <ul>
                        <li class="listr" style="height: 70px;line-height: 70px"><span style="font-size: 28px">￥<span
                                class="yingfu" style="color: red">{{total_price}} 元</span></span></li>
                        <li style="height: 70px;line-height: 70px"><strong>应付金额：</strong></li>
                    </ul>
                </div>
            </div>
        </div>

        <div>
            <el-button @click="pay"
                       style="float: right;margin: 20px 5px 20px 0;background: #E6BE8A;border-color: #E6BE8A;"
                       type="warning" size="mini">提交订单
            </el-button>
        </div>

    </div>
</template>

<script>

    export default {
        data() {
            return {
                price_list: [
                    {name: 1666, price: 100, val: 1},
                    {name: 3333, price: 200, val: 2},
                    {name: 5000, price: 300, val: 3},
                    {name: 10000, price: 600, val: 4},
                    {name: 2000, price: 100, val: 5},
                    // {name: 100, price: 0.01, val: 6},
                ],
                ul_index: -1,
                token: '',
                nodata: false,
                center_id: '',//中心ID
                code_img: '',//二维码
                total_price: 0,//总金额
                note: 0,//短信条数
                dialogVisible: false,//付款码
                scan_code: '',//二维码
                order_id: '',//订单号
                note_id: '',//短信包ID
                setT: '',//清除持续调用
            };
        },
        created() {
            this.token = this.$cookies.get('token');
            this.get_list()
        },
        methods: {
            handleClose(done) {
                this.$confirm('取消支付将导致充值失败,是否确认？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            },
            //表格数据
            get_list() {
                let that = this
                $.ajax({
                    url: process.env.apiUrl + 'saas/dx/chongzhi',
                    type: 'post',
                    data: {
                        token: that.token,
                    },
                    success: function (data, status) {
                        that.center_id = data.centre_id
                        if (data.status == 2) {
                            that.nodata = true
                        }
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
            //短信包
            tabs(index, val, n, p) {
                this.ul_index = index
                this.total_price = p
                this.note = n
                this.note_id = val
            },
            //订单号
            get_order() {
                let that = this
                $.ajax({
                    url: process.env.apiUrl + 'weixinapi/example/native.php',
                    type: 'post',
                    data: {
                        token: that.token,
                        centre_id: that.center_id,
                        number: that.note_id,
                    },
                    success: function (data, status) {
                        let d = JSON.parse(data)
                        if (d.status == 1) {
                            that.code_img = d.er
                            that.order_id = d.dindan

                            setTimeout(() => {
                                $.ajax({
                                    url: process.env.apiUrl + 'saas/dx/qrcode',
                                    type: 'post',
                                    data: {
                                        token: that.token,
                                        data: that.code_img
                                    },
                                    success: function (data2, status) {
                                        if (data2.status == 1) {
                                            that.scan_code = 'data:image/jpeg;base64,' + data2.img
                                            that.setT = setInterval(() => {
                                                that.pay_status()
                                            }, 3000)
                                        }
                                    },
                                    fail: function (err2, status) {
                                        console.log(err2)
                                    }
                                })
                            }, 300)
                        }
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
            //支付
            pay() {
                if (this.ul_index == -1) {
                    this.$message.error({
                        message: '请先选择短信包'
                    })
                } else {
                    this.dialogVisible = true
                    this.get_order()
                }
            },
            //支付成功
            pay_status() {
                let that = this
                if(!that.dialogVisible){
                    clearInterval(that.setT)
                    return;
                }
                $.ajax({
                    url: process.env.apiUrl + 'weixinapi/example/orderquery.php',
                    type: 'post',
                    data: {
                        token: that.token,
                        out_trade_no: that.order_id,
                    },
                    success: function (data) {
                        if (JSON.parse(data) == 'SUCCESS') {
                            clearInterval(that.setT)
                            that.dialogVisible = false
                            that.$message({
                                message: '支付成功',
                                type: 'success'
                            })
                            setTimeout(() => {
                                that.$router.push({path: 'duanxin'})
                            }, 500)

                        }
                    },
                    fail: function (err, status) {
                        console.log(err)
                    }
                })
            },
            jump: function (d) {
                this.$router.push(d)
            },
        }
    }
</script>

<style scoped>
    .body {
        padding-left: 45px;
        padding-right: 45px;
    }

    ul {
        list-style: none;
    }

    .cont_title {
        padding-left: 7px;
        height: 24px;
        line-height: 24px;
        font-size: 14px;
        border-left: 6px solid #E6BE8A;
        margin-top: 14px;
        margin-bottom: 10px;
    }

    .returnBtn {
        width: 80px;
        height: 24px;
        line-height: 24px;
        color: #fff;
        background: #E6BE8A;
        border-radius: 12px;
        text-align: center;
        float: right;
        font-size: 12px;
    }

    .chongzhiLi {
        width: 100%;
        height: 100%;
        border: 1px solid #dbdbdb;
        border-radius: 5px;
        box-shadow: 1px 1px 4px #dbdbdb;
    }

    .duanxinBox {
        margin-top: 35px;
        padding-left: 36px;
        list-style: none;
    }

    .duanxinBox li {
        float: left;
        cursor: pointer;
        border: 1px solid #999;
        width: 170px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        border-radius: 19px;
        margin-right: 38px;
        box-shadow: 1px 1px 4px #dbdbdb;
    }

    .duanxinBox li.active {
        color: #fff;
        background: #fcb06a;
        border: none;
        box-shadow: 1px 1px 4px #dbdbdb;
        cursor: pointer;
    }

    .chongzhiLiT {
        font-size: 14px;
        padding-top: 16px;
        padding-left: 32px;
    }

    .querendingd {
        width: 100%;
        margin-top: 24px;
        border: 1px solid #dbdbdb;
        box-shadow: 1px 1px 4px #dbdbdb;
        height: 244px;
    }

    .queT {

        padding-left: 36px;
        font-size: 16px;
        font-weight: bold;
        height: 42px;
        line-height: 42px;
    }

    .listB {

        padding-left: 45px;
        padding-right: 45px;
        height: auto;
    }

    .listsT {
        width: 100%;
        height: 40px;
        border-bottom: 1px dashed #7c73bf;
    }

    .listsT ul li {
        float: right;
        height: 40px;
        line-height: 40px;
    }

    .listr {
        width: 236px;
        text-align: right;
        padding-right: 10px;
    }

    .youhui {
        width: 100%;
        margin-top: 16px;
        padding-top: 34px;
        padding-bottom: 34px;
        border-width: 2px;
        border-style: solid;
        border-color: #E6BE8A;
        border-image: initial;
    }

    .youhui .tehui {
        float: left;
        background: #E6BE8A;
        color: #fff;
        padding: 7px 36px;
        margin-left: 40px;
        border-radius: 22px;
        cursor: pointer;
    }

    .youhui .tehuiA {
        float: left;
        padding: 7px 36px;
        margin-left: 40px;
        border-radius: 22px;
        border: 1px solid gray;
        cursor: pointer;
    }

    .youhui .tehuiB {
        width: 80px;
        height: 26px;
        color: rgb(255, 255, 255);
        line-height: 26px;
        text-align: center;
        float: left;
        margin-left: 20px;
        margin-top: 6px;
        background: #E6BE8A;
        border-radius: 3px;
    }

    .youhui .right_txt {
        padding-right: 16px;
        height: 38px;
        line-height: 38px;
        float: right;
    }

    .el-dialog__body {
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/duanxin/chongzhi.vue